/*
 * Gavanna - Safari / WebKit + Reduce Motion guvenlik agi
 * ------------------------------------------------------
 * Tema <animate-image> gorsellerini CSS ile gizleyip Motion JS ile aciyor.
 * Asagidaki durumlarda gorsel kalici olarak opacity:0 takili kalabiliyor:
 *   1) Ziyaretcide "Reduce Motion" acik  -> AnimateImage erken return ediyor.
 *   2) Motion (vendor.js) yuklenemedi      -> hicbir sey gorseli acmiyor.
 *   3) Safari WAAPI clip-path animasyonu basarisiz -> gorsel goruse girse de takili kaliyor.
 * Bu script, calisan scroll animasyonlarini bozmadan yalnizca "takili kalan" gorselleri acar.
 */
(function () {
  "use strict";

  var reduceMotion = false;
  try {
    reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  } catch (e) {}

  function isHidden(img) {
    try {
      return parseFloat(getComputedStyle(img).opacity || "1") < 0.05;
    } catch (e) {
      return false;
    }
  }

  function reveal(el) {
    el.classList.add("gv-revealed");
  }

  function revealAllStuck() {
    document.querySelectorAll("animate-image").forEach(function (el) {
      var img = el.querySelector("img");
      if (img && isHidden(img)) reveal(el);
    });
  }

  function watchAndReveal() {
    if (!("IntersectionObserver" in window)) {
      revealAllStuck();
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          io.unobserve(el);
          // Calisan Motion animasyonu ~1sn icinde gorseli acar; hala gizliyse takilmistir.
          setTimeout(function () {
            var img = el.querySelector("img");
            if (img && isHidden(img)) reveal(el);
          }, 1500);
        });
      },
      { rootMargin: "0px" }
    );
    document.querySelectorAll("animate-image").forEach(function (el) {
      io.observe(el);
    });
  }

  function boot() {
    // 1 & 2: JS hic acmayacak -> hepsini hemen ac.
    if (reduceMotion || typeof window.Motion === "undefined") {
      revealAllStuck();
    } else {
      // 3: Goruse girip takili kalanlari yedek olarak ac.
      watchAndReveal();
    }
    window.addEventListener("pageshow", function (e) {
      if (e.persisted) revealAllStuck();
    });
  }

  if (document.readyState === "complete") boot();
  else window.addEventListener("load", boot);
})();
